import { render, staticRenderFns } from "./ManuscriptListItem.vue?vue&type=template&id=74ac2227&scoped=true"
import script from "./ManuscriptListItem.vue?vue&type=script&lang=ts"
export * from "./ManuscriptListItem.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptListItem.vue?vue&type=style&index=0&id=74ac2227&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ac2227",
  null
  
)

export default component.exports